import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { fromOrder, useAppDispatch } from '../../../store';
import { CustomLink } from '../../../components';
import { CUSTOMER_PRIVACY_POLICY, CUSTOMER_TERM_OF_USED } from '../../../utils/Constants';

export const TermAndConditionCheck = (
  { redesign }: {
    /** Payment & billing v1 redesign: green checked state instead of purple */
    redesign?: boolean;
  },
) => {
  const checked = useSelector(fromOrder.selectTermsAndConditionsAccepted);
  const dispatch = useAppDispatch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(fromOrder.updateTermsAndConditionsAccepted(event.target.checked));
  };

  return (
    <Box
      id="expand-plan-price-summary-terms-and-conditions"
      display="flex"
      flexDirection="row"
      paddingY={0.75}
    >
      <Box
        id="expand-plan-price-summary-terms-and-conditions"
        display="flex"
        flexDirection="row"
        paddingRight={0.75}
      >
        <Checkbox
          size="small"
          checked={checked}
          onChange={handleChange}
          required
          inputProps={{ 'aria-label': 'controlled' }}
          sx={{
            height: 20,
            width: 20,
            color: 'primary',
            padding: 0,
            '&.Mui-checked': {
              color: redesign ? '#0f8461' : '#5959EB',
            },
          }}
        />
      </Box>
      <Box
        id="expand-plan-price-summary-terms-and-conditions"
        display="flex"
        flexDirection="row"
      >
        <Typography variant="body1" fontWeight={400} fontSize={13}>
          <FormattedMessage
            id="page.checkout.term.and.condition.check.label"
            values={{
              term: (
                <CustomLink href={CUSTOMER_TERM_OF_USED}>
                  <FormattedMessage id="page.checkout.term.and.condition.term" />
                </CustomLink>
              ),
              policy: (
                <CustomLink href={CUSTOMER_PRIVACY_POLICY}>
                  <FormattedMessage id="page.checkout.term.and.condition.policy" />
                </CustomLink>
              ),
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
};
